export enum InteractionType {
	CLICK = 'CLICK',
	VIEW = 'VIEW',
	EVENT = 'EVENT',
}

export enum InteractionMedium {
	PATIENT_APP = 'PATIENT_APP',
}

export interface InteractionIdentity {
	email?: string
}

export interface InteractionDetailBase {
	actionType: InteractionType
	medium: InteractionMedium
	properties?: Record<string, string | number | boolean> | null
}

export interface InteractionViewDetails extends InteractionDetailBase {
	pageUrl?: string
}

export interface InteractionClickDetails extends InteractionDetailBase {
	pageUrl?: string
	clickName?: string
}

export interface InteractionEventDetails extends InteractionDetailBase {
	pageUrl?: string
	eventName?: string
}

export type InteractionDetails =
	| InteractionClickDetails
	| InteractionEventDetails
	| InteractionViewDetails

export interface InteractionDevice {
	platform: string | null
	deviceType?: string | null
	isRealDevice: boolean | null
	deviceModel: string | null
	deviceVersion: string | null
	appPlatform: string | null
	appVersion?: string | null
	easVersion: string | null
}

export interface Interaction {
	appId?: string
	eventId: string
	userId?: number | null
	anonymousId?: string | null
	details: InteractionDetails
	identity: InteractionIdentity
	utms: Record<PropertyKey, never>
	device: InteractionDevice
	ad: Record<PropertyKey, never>
	referral: Record<PropertyKey, never>
	createdAt: string
	occurredAt: string
}
